export { default as VictoryLegend } from "./victory-legend";